export const initialState = {
  user: null,
  playlists: [],
  playing: false,
  item: null,
  // debug line
  // token:
  //   "BQCPmtEmV8-p_f-lCS0wb7OttgS_DXAS-LCbEtxpzyJ4s1_74gtDOh_NBYrXCY31B4wZpcDWa02eqYS97pyHOlP9ATcaSa_ykpgxnNbIQAp8YtbYB37Bp3f5kiQStlpdd2o7ZifMFsZSBLNGBFjJXCqtvuPmv3QAyYVYZJ0wraL5FWhExgjQ",
};



const reducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };

    case "SET_TOKEN":
      return {
        ...state,
        token: action.token,
      };

    case "SET_PLAYLISTS":
      return {
        ...state,
        playlists: action.playlists,
      };
    case "SET_DISCOVER_WEEKLY":
      return {
        ...state,
        discover_weekly: action.discover_weekly,
      };
    default:
      return state;
  }
};
export default reducer;
